'use client';

import { __awaiter, __generator } from '../../_virtual/_tslib.js';
import { FIRST_EMBED, TIKTOK_EMBED_ENDPOINT } from './const.js';
import ModelError from '../model/index.js';

function getTikTokEmbed(baseMsUrl, langCode, groupJobFuncions) {
    return __awaiter(this, void 0, void 0, function () {
        var groupJobFunctionStr, response, data, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    groupJobFunctionStr = "".concat(groupJobFuncions.join(','));
                    if (groupJobFuncions.length > 0) {
                        groupJobFunctionStr = "?group_job_function_ids=".concat(groupJobFunctionStr);
                    }
                    return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(TIKTOK_EMBED_ENDPOINT).concat(groupJobFunctionStr), {
                            method: 'GET',
                            headers: {
                                'Accept-Language': langCode
                            }
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    if (data && data.length > FIRST_EMBED) {
                        return [2 /*return*/, data[0]];
                    }
                    return [2 /*return*/, new ModelError({
                            data: null,
                            error: {
                                details: {
                                    ERROR_TIKTOK_EMBED: 'ERROR_TIKTOK_EMBED'
                                },
                                message: 'ERROR_TIKTOK_EMBED',
                                status: 500
                            }
                        })];
                case 3:
                    err_1 = _a.sent();
                    console.error(err_1);
                    return [2 /*return*/, new ModelError({
                            data: err_1,
                            error: {
                                details: {
                                    ERROR_TIKTOK_EMBED: err_1
                                },
                                message: 'ERROR_TIKTOK_EMBED',
                                status: 500
                            }
                        })];
                case 4: return [2 /*return*/];
            }
        });
    });
}

export { getTikTokEmbed };
//# sourceMappingURL=index.js.map
